<template>
  <div class="row">
    <!-- General Top Bar -->
    <!-- <general-top-bar :title="$t('pages.pos')"></general-top-bar> -->
    <!-- End General Top Bar -->
    <div class="box-container row">
      <div 
        v-for="(route, index) in routess" 
        :key="route.name" 
        class="col-md-4"
      >
        <router-link 
          :to="route.path" 
          class="box" 
          :style="{ backgroundColor: getBoxColor(index) }"
        >
        <div class="title">{{ route.name }}</div>
          <div class="image">
            <img :src="getImageForRoute(route.name)" :alt="'Image for ' + route.name" />
          </div>
        </router-link>
      </div>
      </div>
  </div>
</template>
  
<script>
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  
  export default {
    components: {
      // GeneralTopBar
    },
    data () {
      return {
        routess: [
          { path: '/pos/tabs?tabIndex=0', name: this.$t('pages.tableMaps') },
          { path: '/pos/tabs?tabIndex=1', name: this.$t('pages.pos') },
          { path: '/pos/tabs?tabIndex=2', name: this.$t('dispath.users') },
          { path: '/pos/tabs?tabIndex=5', name: 'Fiscal Printer' },
          { path: '/pos/tabs?tabIndex=6', name: 'Cantar' },
          { path: '/pos/tabs?tabIndex=3', name: 'Report' },
          { path: '/pos/tabs?tabIndex=4', name: 'Settings' }
        ]
      }
    },
    methods: {
      getImageForRoute (routeName) {
        const images = {}
        images[this.$t('pages.tableMaps')] = 'static/img/tableMapsBg.png'
        images[this.$t('pages.pos')] = 'static/img/posBg.png'
        images[this.$t('dispath.users')] = 'static/img/posUsersBg.png'
        images['Report'] = 'static/img/pickupBg.png'
        images['Settings'] = 'static/img/pickupBg.png'
        images['Fiscal Printer'] = 'static/img/fiscalPrinterBg.png'
        images['Cantar'] = 'static/img/cantarBg.png'

        return images[routeName] || 'static/img/default.jpg'
      },
      getBoxColor (index) {
        const colors = [
          '#FFD93D',
          '#3AB7CD', // First box
          '#674BD2',
          '#FF4D4D',
          '#5dd5a2',
          '#FFD93D',
          '#3AB7CD'
        ]
        return colors[index] || '#FFFFFF' // Default color
      }
    }
  }
  </script>
  
  <style scoped>
   .box-container.row {
    max-width: 940px;
    margin: auto;
  }
  .box-container.row .image {
    position: absolute;
    bottom: 0;
  }
  .box {
    position: relative;
    margin-bottom: 30px;
    text-align: center;
    display: block;
    text-decoration: none;
    color: inherit;
    border-radius: 30px;
    width: 280px;
    height: 280px;
  }
  .title {
    margin-bottom: 8px;
    padding: 30px 0px;
    color: #fff;
    font-size: 20px;
    font-weight: 500;
  }
  .image img {
    width: 100%;
    height: auto;
    max-width: 100%;
    display: block;
    margin: 0 auto 0px;
  }
</style>
  


// WEBPACK FOOTER //
// src/components/Dashboard/Views/PosSettings/PosView.vue